import { c as _c } from "react/compiler-runtime";
import { Combobox } from '@7f-ui/components/combobox/combobox';
import { Clock } from '@phosphor-icons/react';
import { useState } from 'react';
interface TimeComboboxProps {
  value?: string;
  name?: string;
  label?: string;
  error?: string | undefined;
  required?: boolean;
  onChange: (value: string) => void;
}
export function TimeCombobox(t0) {
  const $ = _c(15);
  const {
    value,
    label,
    error,
    required,
    onChange
  } = t0;
  const [searchTerm, setSearchTerm] = useState("");
  let allOptions;
  let t1;
  if ($[0] !== searchTerm) {
    const times = Array.from({
      length: 24
    }, _temp);
    allOptions = [{
      id: "flexible",
      label: "Ich bin flexibel."
    }, ...times];
    t1 = searchTerm ? allOptions.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase())) : allOptions;
    $[0] = searchTerm;
    $[1] = allOptions;
    $[2] = t1;
  } else {
    allOptions = $[1];
    t1 = $[2];
  }
  const filteredOptions = t1;
  let t2;
  if ($[3] !== onChange) {
    t2 = selected => {
      onChange(selected ? selected.id : "");
      setSearchTerm("");
    };
    $[3] = onChange;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleChange = t2;
  let t3;
  if ($[5] !== allOptions || $[6] !== value) {
    t3 = allOptions.find(option_0 => option_0.id === value) ?? null;
    $[5] = allOptions;
    $[6] = value;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== error || $[9] !== filteredOptions || $[10] !== handleChange || $[11] !== label || $[12] !== required || $[13] !== t3) {
    t4 = <Combobox Icon={Clock} options={filteredOptions} onChange={handleChange} value={t3} label={label} getDisplayValue={_temp2} renderOption={_temp3} onInputChange={setSearchTerm} error={error} required={required} />;
    $[8] = error;
    $[9] = filteredOptions;
    $[10] = handleChange;
    $[11] = label;
    $[12] = required;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  return t4;
}
function _temp3(option_2) {
  return option_2.label;
}
function _temp2(option_1) {
  return option_1?.label ?? "";
}
function _temp(_, i) {
  const hour = i.toString().padStart(2, "0");
  return {
    id: `${hour}:00`,
    label: `${hour}:00`
  };
}